import { render, staticRenderFns } from "./ContactFormHeader.vue?vue&type=template&id=2863127c&"
import script from "./ContactFormHeader.vue?vue&type=script&lang=js&"
export * from "./ContactFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports